// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CarFilledSvg from "@fishx/icons-svg/es/asn/CarFilled";
import FishxIcon from '../components/FishxIcon';

var CarFilled = function CarFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CarFilledSvg
  }));
};

CarFilled.displayName = 'CarFilled';
export default React.forwardRef(CarFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CarFilled.js
// module id = 2155
// module chunks = 0